module.exports = __webpack_public_path__ + "media/investors/streamlined-registration-3308dd74.png";